import React, { FC } from 'react';

import usePrefix from 'utils/usePrefix';
import { ResqlExpertSubmissionListItem } from 'utils/api/resqlexpert.d';

import Button from 'components/Button';
import SubmissionsListBase from 'components/ResqlExpert/SubmissionsList';

interface Props {
  items: ResqlExpertSubmissionListItem[];
  hasMore: boolean;
  loading: boolean;
  error: Error | null;
  loadMore: () => void;
  retry: () => void;
  selectedId?: number;
  setSelectedId: (id: number) => void;
  query: string;
  setQuery: (q: string) => void;
  onAdd: () => void;
}

const SubmissionsList: FC<Props> = ({ onAdd, ...rest }) => {
  const t = usePrefix('ResqlExpert');
  return (
    <SubmissionsListBase
      {...rest}
      headerAction={<Button onClick={onAdd} label={t('new_submission')} color="link" noPadding />}
    />
  );
};

export default SubmissionsList;
